var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCushion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.0576 31.7199L21.3336 33.6079L10.6096 31.7199L8.72559 20.9999L10.6096 10.2759L21.3336 8.38794L32.0576 10.2759L33.9416 20.9999L32.0576 31.7199Z",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M32.9175 4.692L21.3335 1L9.74951 4.692L21.3335 8.388L32.9175 4.692Z",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.02949 9.41602L1.3335 21L5.02949 32.584L8.7255 21L5.02949 9.41602Z",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.74951 37.3039L21.3335 40.9999L32.9175 37.3039L21.3335 33.6079L9.74951 37.3039Z",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M37.6374 32.584L41.3334 21L37.6374 9.41602L33.9414 21L37.6374 32.584Z",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M5.02954 9.41589L10.6095 10.2759L9.74955 4.69189",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M5.02953 9.41603L4.16553 3.83203L9.74954 4.69203",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M32.9174 4.69189L32.0574 10.2759L37.6374 9.41589",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M32.9175 4.69203L38.5015 3.83203L37.6375 9.41603",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M37.6374 32.584L32.0574 31.72L32.9174 37.304",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M37.6375 32.584L38.5015 38.164L32.9175 37.304",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M9.74955 37.304L10.6095 31.72L5.02954 32.584",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M9.74954 37.304L4.16553 38.164L5.02953 32.584",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M4.16553 3.83201L9.22953 1H21.3335",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M38.5015 3.83201L33.4375 1H21.3335",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M4.16553 38.1641L9.22953 41H21.3335",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M38.5015 38.1641L33.4375 41H21.3335",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M4.16549 38.164L1.3335 33.104V21",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M4.16549 3.83203L1.3335 8.89603V21",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M38.5015 38.164L41.3335 33.104V21",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M38.5015 3.83203L41.3335 8.89603V21",
    stroke: "black",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCushion);
export default __webpack_public_path__ + "static/media/cushion.1ca7227271e521e400090a0f43d96219.svg";
export { ForwardRef as ReactComponent };